const osloDay = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Oslo',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
})

export function newsDateInput(timestamp: string): string {
  const parts = osloDay.formatToParts(new Date(timestamp))
  return ['year', 'month', 'day']
    .map((type) => parts.find((part) => part.type === type)?.value)
    .join('-')
}

export function newsDayStart(day: string): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) throw new Error('Velg en gyldig dato.')
  const midnight = Date.parse(`${day}T00:00:00Z`)
  if (
    !Number.isFinite(midnight) ||
    new Date(midnight).toISOString().slice(0, 10) !== day
  ) {
    throw new Error('Velg en gyldig dato.')
  }
  const clock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Oslo',
    hourCycle: 'h23',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
  let instant = midnight
  // Resolve Oslo midnight rather than adding 24 hours across a DST boundary.
  for (let i = 0; i < 3; i++) {
    const parts = clock.formatToParts(new Date(instant))
    const value = (type: string) =>
      Number(parts.find((part) => part.type === type)?.value)
    const local = Date.UTC(
      value('year'),
      value('month') - 1,
      value('day'),
      value('hour'),
      value('minute'),
      value('second')
    )
    instant += midnight - local
  }
  return new Date(instant).toISOString()
}

export function newsDayEnd(day: string): string {
  newsDayStart(day)
  const nextDay = new Date(`${day}T00:00:00Z`)
  nextDay.setUTCDate(nextDay.getUTCDate() + 1)
  return new Date(
    Date.parse(newsDayStart(nextDay.toISOString().slice(0, 10))) - 1
  ).toISOString()
}

export function newsTimestamp(
  day: string,
  original: string | undefined,
  endOfDay = false
): string {
  if (original && day === newsDateInput(original)) return original
  return endOfDay ? newsDayEnd(day) : newsDayStart(day)
}

export function formatNewsDate(timestamp: string): string {
  return new Intl.DateTimeFormat('nb-NO', {
    timeZone: 'Europe/Oslo',
    dateStyle: 'medium'
  }).format(new Date(timestamp))
}
